export function AuthorizationsAccessMatrix({
  title,
  description,
  roles,
  rows,
  filter,
  onFilterChange,
  onToggle,
  onSetAllRoles,
  testIdPrefix,
  showMethod = false,
}) {
  const q = filter.trim().toLowerCase();
  const visible = q
    ? rows.filter(
        (row) =>
          row.label.toLowerCase().includes(q) ||
          (row.path || '').toLowerCase().includes(q) ||
          row.group.toLowerCase().includes(q) ||
          (row.method || '').toLowerCase().includes(q),
      )
    : rows;

  return (
    <section
      className="rounded-2xl border border-slate-200/80 bg-white p-4"
      data-testid={`${testIdPrefix}-matrix`}
    >
      <h2 className="text-sm font-semibold text-slate-900">{title}</h2>
      <p className="mt-1 text-xs text-slate-500">{description}</p>
      <input
        className="mt-3 w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
        value={filter}
        onChange={(e) => onFilterChange(e.target.value)}
        placeholder="Filter by name, path, or group…"
        data-testid={`${testIdPrefix}-filter`}
      />
      {roles.length === 0 ? (
        <p className="mt-3 text-xs text-amber-700">Add organisation roles first to assign access.</p>
      ) : (
        <div className="mt-3 max-h-[28rem] overflow-auto">
          <table className="min-w-full border-collapse text-left text-xs">
            <thead className="sticky top-0 bg-white">
              <tr className="border-b border-slate-200 text-slate-500">
                <th className="px-2 py-2 font-medium">Resource</th>
                <th className="px-2 py-2 font-medium">All</th>
                {roles.map((role) => (
                  <th key={role} className="whitespace-nowrap px-2 py-2 font-medium">
                    {role}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {visible.map((row) => {
                const allChecked =
                  roles.length > 0 && roles.every((role) => row.allowed_roles.includes(role));
                return (
                  <tr key={row.id} className="border-b border-slate-100 align-top">
                    <td className="px-2 py-2 text-slate-800">
                      <div className="font-medium">{row.label}</div>
                      <div className="text-[11px] text-slate-400">
                        {showMethod && row.method ? `${row.method} ` : ''}
                        {row.path || row.id} · {row.group}
                      </div>
                    </td>
                    <td className="px-2 py-2">
                      <input
                        type="checkbox"
                        checked={allChecked}
                        onChange={(e) => onSetAllRoles(row.id, e.target.checked)}
                        aria-label={`Toggle all roles for ${row.label}`}
                      />
                    </td>
                    {roles.map((role) => (
                      <td key={`${row.id}-${role}`} className="px-2 py-2">
                        <input
                          type="checkbox"
                          checked={row.allowed_roles.includes(role)}
                          onChange={() => onToggle(row.id, role)}
                          aria-label={`${row.label} — ${role}`}
                          data-testid={`${testIdPrefix}-${row.id}-${role}`}
                        />
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
          {visible.length === 0 ? (
            <p className="py-4 text-center text-xs text-slate-400">No matching rows.</p>
          ) : null}
        </div>
      )}
    </section>
  );
}
